<template>
  <div>
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-success">
      <div class="accordion" role="tablist">
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <h3 class="card-title"><b-button size="sm" v-b-toggle.accordion-1 variant="info"><i class="fa fa-filtro"></i></b-button>Filtros </h3>

          </b-card-header>
          <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel">
            <b-card-body>
              <!--b-card-text>I start opened because <code>visible</code> is <code>true</code></b-card-text>
              <b-card-text>{{ text }}</b-card-text>-->
              <b-row>
                <b-col sm="3">
                    <select name="tiendaId" v-on:change="onChangeSelectCajas" v-model="filtro.tiendaId" id="tiendaId" class="form-control form-control-sm" :class="{ 'is-invalid': filtro.errors.has('tiendaId') }">
                        <option value="-1">Todos las Tiendas</option>
                        <option v-for="itemc in selectTienda" :value="itemc.value"  v-bind:key="itemc.value">
                            {{itemc.text}}
                        </option>
                    </select>
                </b-col>
                <b-col sm="3">
                    <select name="idCaja" v-on:change="onFiltroChange" v-model="filtro.cajaId" id="idCaja" class="form-control form-control-sm" :class="{ 'is-invalid': filtro.errors.has('idCaja') }">
                        <option value="0">Todos las Cajas</option>
                        <option v-for="itemc in selectCajas" :value="itemc.codigoCaja"  v-bind:key="itemc.id">
                            {{itemc.codigoCaja}}
                        </option>
                    </select>
                </b-col>
                <b-col sm="3">
                    <b-input-group size="sm" prepend="Monto">
                      <b-form-input size="sm" id="monto" type="text" v-on:change="onFiltroChange" v-model="filtro.monto" value="" placeholder="0.00"></b-form-input>
                    </b-input-group>
                  </b-col>
                <b-col sm="3" class="text-center">
                        <b-button title="Aplicar filtro" :class="{'btn btn-success' :filtroActivo, 'btn btn-light':!filtroActivo}" @click="aplicarFiltro()"><i :class="{'fas fa-check':filtroActivo,'fas fa-ban':!filtroActivo}"></i></b-button>
                        <b-button title="Resetear filtro" variant="primary" @click="resetFiltro()"><i class="fas fa-undo"></i></b-button>
                </b-col>
              </b-row>
              <b-row>
                  <b-col sm="3">
                    <b-form-input class="form-control form-control-sm float-right" id="fecha" type="date" v-on:change="onFiltroChange" v-model="filtro.fecha" name="fecha" min="01-01-2000"
              max="31-12-3000"></b-form-input>
                  </b-col>
                  <b-col sm="3">
                    <b-input-group size="sm" prepend="Rif/Cédula">
                      <b-form-input size="sm" id="cedula" type="text" v-on:change="onFiltroChange" v-model="filtro.cedula" value="" placeholder="0000000"></b-form-input>
                    </b-input-group>
                  </b-col>
                  <b-col sm="3">
                    <!--<b-button size="sm" @click="cierreTurnos()" block  variant="success">Turnos Procesados</b-button>-->
                  </b-col>
              </b-row>
            </b-card-body>
          </b-collapse>
        </b-card>
      </div>
    </base-header>
    <b-container fluid class="mt--7">
      <b-row>
        <b-col>
          <b-card no-body>
              <b-card-header class="border-0">
                  <h3 class="mb-0">Devoluciones</h3>
              </b-card-header>
              <div class="card-body table-responsive p-0">
                <table class="table table-hover">
                  <tbody>
                    <tr class="thead-light text-center">
                        <th>Tienda</th>
                        <th>Turno</th>
                        <th>IdDev</th>
                        <th>Nro Devolucion</th>
                        <th class="text-right">Monto Bs. Devolucion </th>
                        <th>Nro Factura</th>
                        <th class="text-right">Monto Bs. Factura </th>
                        <th>Acciones</th>
                  </tr>
                  <tr class="text-center" v-for="devolucion in devoluciones" :key="devolucion.idDevolucion">
                    <td>{{devolucion.tiendaId}}</td>
                    <td><h3><b-badge variant="primary">{{devolucion.idTurno}}</b-badge></h3></td>
                    <td>{{devolucion.idDevolucion}}</td>
                    <td>{{devolucion.numeroDevolucion}}</td>
                    <td class="text-right"><h5>{{devolucion.montoDevolucion | moneda}}</h5></td>
                    <td><h4 v-b-popover.hover.top="'Ver Factura'" class="micursor" @click="verDetalleFactura(devolucion)">{{devolucion.numeroFactura}}</h4></td>
                    <td class="text-right"><h5>{{devolucion.montoFactura | moneda}}</h5></td>
                    <td>
                        <base-button size="sm" type="secondary" title="Ver Factura" @click="verDetalleFactura(devolucion)">
                          <i class="fa fa-tasks"></i>
                        </base-button>
                        <base-button size="sm" title="Ver Turno Devolución" type="secondary"
                        @click="verTurnoCaja(devolucion)"
                        v-if="filtro.idCaja!=='0'">
                            <i class="fas fa-eye"></i>
                        </base-button>
                    </td>
                  </tr>
                  <tr v-if="devoluciones.length === 0">
                    <td  class="text-center" colspan="6"> <h2>No hay Información</h2></td>
                  </tr>
                </tbody></table>
              </div>
              <b-card-footer class="py-4 d-flex justify-content-end">
                  <base-pagination @change="getResults" v-model="currentPage" :per-page="perPage" :total="totalItemsRow"></base-pagination>
              </b-card-footer>
          </b-card>
        </b-col>
      </b-row>
      <div class="mt-5"></div>
    </b-container>

    <!-- Modal Detalle Producto-->
    <b-modal ref="modal-detalleProducto" size="md" title="Detalle de Factura" ok-only>
      <b-list-group-item href="javascript:;" class=" flex-column align-items-start py-4 px-4">
        <div class="d-flex w-100 justify-content-between">
          <div>
            <div class="d-flex w-100 align-items-center">
              <img src="img/theme/producto.png" alt="Image placeholder" class="avatar avatar-xs mr-2">
              <h5 class="mb-1">{{productoActual.descripcion}}</h5>
            </div>
          </div>
          <small>Fecha: {{productoActual.fecha | myDate}}</small>
        </div>
        <h4 class="mt-3 mb-1">Código: {{productoActual.codigoProducto }}</h4>
        <b-list-group flush>
          <b-list-group-item href="#">Precio: {{productoActual.precioBolivar | moneda}} Bs.</b-list-group-item>
          <b-list-group-item href="#">Precio: {{productoActual.precioDolar | moneda}} $</b-list-group-item>
          <b-list-group-item href="#">Tasa: {{productoActual.tasa}} Bs.</b-list-group-item>
        </b-list-group>
      </b-list-group-item>
    </b-modal>

      <!-- Detalle pago -->
      <b-modal ref="modal-DetalleFactura" hide-backdrop  size="xl" ok-only>
        <template #modal-title>
          <h5 class="modal-title">Detalle de Factura</h5>
        </template>
        <p>
          <!--Total Dolares: {{detalleMoneda[0].totalMoneda | moneda}} - Total Bolivares: {{detalleMoneda[1].totalMoneda | moneda}}
          <b-button v-b-modal.modal-multi-3 size="sm">Open Third Modal</b-button>-->
        </p>
        <table width="100%" class="detallefactura table-bordered">
          <tr>
            <th width="12%">Documento:</th>
            <td><b>{{facturaActual.numeroControl}}</b></td>
            <th>Tasa:</th>
            <td class="fondotasa text-right">{{facturaActual.tasa | moneda}} Bs.</td>
          </tr>
          <tr>
            <th>Cliente:</th>
            <td>{{detalleDeFactura.cliente.nombre}} {{detalleDeFactura.cliente.apellido}}</td>
            <th>Teléfono:</th>
            <td>{{detalleDeFactura.cliente.telefono}}</td>
          </tr>
          <tr>
            <th>RIF/C.I:</th>
            <td>{{detalleDeFactura.cliente.cedRif}}</td>
            <th>Cod. Afil.:</th>
            <td>00999</td>
          </tr>
          <tr>
            <th>Dir.:</th>
            <td colspan="3">{{detalleDeFactura.cliente.direccion}}</td>
          </tr>
          <tr>
            <th>Cajero:</th>
            <td>{{cajero.nombre}} {{cajero.apellido}}</td>
            <th>Caja:</th>
            <td>{{cajero.codigoCaja}}</td>
          </tr>
          <tr>
            <th>Factura:</th>
            <td colspan="3"><b>{{facturaActual.numeroFactura}}</b></td>
          </tr>
          <tr>
            <th>Fecha:</th>
            <td colspan="3">{{facturaActual.fecha | myDateTime}}</td>
          </tr>
        </table>
        <table class="table table-hover table-bordered">
          <tr class="thead-light">
            <th>DESCRIPCION</th>
            <th>CANT</th>
            <th>PRECIO</th>
            <th>TOTAL</th>
          </tr>
          <tbody>
          <tr v-for="df in detalleDeFactura.detalleFactura" :key="(df.codigoProducto + ind++)" @click="verDetalleProducto(df)"
           :class="{'bckgdevolucion':df.cantidad<0}"
          >
            <td>{{df.descripcion}}</td>
            <td>{{df.cantidad}}</td>
            <td class="text-right">{{df.precioBolivar | moneda}}</td>
            <td class="text-right">{{df.total | moneda}}</td>
          </tr>
          </tbody>
          <tr>
            <th colspan="3" scope="row">SUBTOTAL</th>
            <td class="text-right">{{totalGeneralBs | moneda}}</td>
          </tr>
          <tr>
            <th colspan="3" scope="row">IMPUESTO</th>
            <td class="text-right"><!--{{facturaActual.montoIVAbs | moneda}}--></td>
          </tr>
          <tr v-if="facturaActual.montoDescuentobs>0">
            <th colspan="3" scope="row">DESCUENTO</th>
            <td class="text-right">- {{facturaActual.montoDescuentobs | moneda}}</td>
          </tr>
          <tr>
            <th colspan="3" scope="row">TOTAL BS</th>
            <td class="text-right bckgmontobs">{{totalGeneralBs| moneda}}</td>
          </tr>
          <tr>
            <th colspan="3" scope="row">TOTAL $</th>
            <td class="text-right bckgmontobs">{{totalGeneralBs/facturaActual.tasa| moneda}}</td>
          </tr>
        </table>
        <table class="detallefactura table-bordered">
          <tr>
            <th width="50%">Forma de Pago:</th>
            <th>Monto</th>
          </tr>
          <tr width="50%" v-for="fpf in formasPagoFactura" :key="fpf.id">
            <th>{{fpf.descripcion}}</th>
            <td class="text-right">{{fpf.monto | moneda}}</td>
          </tr>
        </table>
        <template #modal-footer="{ close }">
          <div class="w-100">
            <b-button
              variant="primary"
              size="sm"
              class="float-right"
              @click="close()"
            >
              Cerrar
            </b-button>
          </div>
        </template>
      </b-modal>


  </div>
</template>
<script>
  import { Dropdown, DropdownItem, DropdownMenu, Table, TableColumn } from 'element-ui';
  //import projects from './../../Tables/projects'
  //import cajas from './../../Tables/cajas'
  //import tiendas from './../../Tables/tiendas'
  //import areas from './../../Tables/areas'
  //import detallespago from './../../Tables/detallespago'
  //import Modal from './../../../components/Modal'
  //import LightTable from "./../../Tables/RegularTables/LightTable";
  //import DarkTable from "./../../Tables/RegularTables/DarkTable";

  export default {
    components: {
      //LightTable,
      //DarkTable,
      //Modal,
      [Dropdown.name]: Dropdown,
      [DropdownItem.name]: DropdownItem,
      [DropdownMenu.name]: DropdownMenu,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn
    },
    data() {
      return {
      editmode: false,
      filtroActivo:false,
      ind:1,
      perPage:10,
      currentPage: 1,
      totalItemsRow:10,
      form: new Form({
        id: 0,
        tiendaId: 0,
        codigoCaja: '',
        areaId: '',
        monto: 0,
        estatus: true,
      }),
      filtro: new Form({
        cajaId:'0',
        Turno: 0,
        fecha: this.getDate(),
        estatusDepo:0,
        estatusTurno:0,
        tiendaId:'-1'
      }),
      formasPagoFactura:{},
      detalleDeFactura:{
        cliente: {
          apellido: "",
          cedRif: "",
          direccion: "",
          nombre: "",
          telefono: ""}
        ,detalleFactura:[]},
      cajero:{
          accionesAdc: null,
          apellido: "",
          cedula: "",
          createdAt: "",
          estatus: 1,
          id: 1,
          nick: "",
          nombre: "",
          password: "",
          rolId: 0,
          sucursal: 0,
          tipo: 0,
          updatedAt: "",
          codigoCaja:""
      },
        tiendas:[],
        //detalleCajaArqueo:[],
        devoluciones:[],
        facturaActual:{},
        productoActual:{},
        //areas,
        selectCajas:[],
        selectTienda:[],
        status: [{value:true, text:"Activo"}, {value:false, text:"Inactivo"}],
      };
    },
    methods: {
      async getResults(page = 1) {
        await axios.get(this.$gate.getApiUrl()+'Devolucion/ListadoDevoluciones?page='+page+'&perPage='+this.perPage,{ params: this.filtro })
        .then(({ data }) => {
          if(data){
            this.devoluciones = data.devoluciones;
            this.totalItemsRow = data.totalrow;
          }else{
            this.cajas =[];
          }
        }).catch( e => {
            /* si el token es invalido o esta vencido */
            if (e.response.status == 401) {
               this.$gate.removeLogin();
               this.$router.push("/Login");
            }
        });
      },
      verDetalleFactura: async function(devolucion){

        this.facturaActual = devolucion;
        await axios.get(this.$gate.getApiUrl()+"CajaAdministrativa/DetalleFactura?CajaId="+devolucion.idCaja+"&Factura="+devolucion.numeroFactura+"&ClienteId="+devolucion.idCliente+"&Fecha="+this.filtro.fecha).then(({ data }) => {this.detalleDeFactura = data.data;});
        axios.get(this.$gate.getApiUrl()+"CajaAdministrativa/DetalleCajeraTurno/"+devolucion.idTurno).then(({ data }) => {this.cajero = data.data.cajeraTurno; this.cajero.codigoCaja = data.data.cajaTurno.codigoCaja; });
        await axios.get(this.$gate.getApiUrl()+"CajaAdministrativa/FormaPago/Factura/"+devolucion.idFactura).then(({ data }) => {this.formasPagoFactura = data.data; });
        this.$refs['modal-DetalleFactura'].show();
      },
      verTurnoCaja(dataDev){
        //this.$router.push("turnos?Caja="+this.filtro.cajaId+"&fecha="+this.filtro.fecha);
        let routeUrl = this.$router.resolve({
                  path: "/turnos",
                  //query: {id:96}
                  query: {Caja:this.filtro.cajaId,idTurno:dataDev.idTurno, fecha: this.filtro.fecha},
                  //params: devolucion
            });
        window.open(routeUrl .href, '_blank');
      },
      zfill(number, width=6) {
          var numberOutput = Math.abs(number); /* Valor absoluto del número */
          var length = number.toString().length; /* Largo del número */
          var zero = "0"; /* String de cero */

          if (width <= length) {
              if (number < 0) {
                  return ("-" + numberOutput.toString());
              } else {
                  return numberOutput.toString();
              }
          } else {
              if (number < 0) {
                  return ("-" + (zero.repeat(width - length)) + numberOutput.toString());
              } else {
                  return ((zero.repeat(width - length)) + numberOutput.toString());
              }
          }
      },
      async onChangeSelectCajas(){
        this.filtroActivo = true;
        await axios.get(this.$gate.getApiUrl()+"Caja/tienda/"+this.filtro.tiendaId).then(({ data }) => {this.selectCajas = data;/*this.getSelectTienda();*/ });
      },
      getDate(){
        var currentDate = new Date();
        return currentDate.getFullYear()+"-"+(currentDate.getMonth()<9?"0"+(currentDate.getMonth()+1):(currentDate.getMonth()+1))+"-"+(currentDate.getDate()<10?"0"+currentDate.getDate():currentDate.getDate());
      },
      aplicarFiltro(){
        //if(this.$gate.isAdmin()){
          this.setFilters();
          let loader = this.$loading.show({
            // Optional parameters
            container: this.fullPage ? null : this.$refs.formContainer,
            canCancel: true,
            loader: 'dots',
          });
          this.getResults();
          loader.hide();
      },
      resetFiltro(){
        this.filtro.reset();
        this.filtroActivo = false;
        localStorage.removeItem('filter');
        this.getResults();
      },
      onFiltroChange(){
        this.filtroActivo = true;
      },
      detalleCaja(caja){
        this.$refs['modal-Detalle'].show();
      },
      async getDetalleCaja(cajaData){
        await axios.get(this.$gate.getApiUrl()+"cajaadministrativa/facturadoxturnoxfecha?fechaActual="+this.filtro.fecha + "&caja=" + cajaData.caja + "&page=1&perPage=10" )
          .then( ({ data }) => {
              this.detalleCajaArqueo = data.data;/*this.getSelectTienda();*/
            });
            this.$refs['modal-Detalle-Caja'].show();
      },
      editModal(caja){
        this.editmode = true;
        this.form.reset();
        this.$refs['modal-1'].show();
        //$('#addNew').modal('show');
        this.form.fill(caja);
      },
      updateCaja(){
        console.log('Actualizar Data');
        this.hideModal();
      },
      hideModal() {
        this.$refs['modal-1'].hide();
      },
      createCaja(){

      },
      totalDetalle(pagoFacturaElectronico){

      },
      getArea(areaId){
        //console.log(this.areas)
        if(this.areas.length >0){
          let itemEnc = this.areas.find(m => m.value === areaId);
          if(areaId>=0){
            //console.log(itemEnc)
            //return itemEnc.text;
          }else{
            return "---";
          }
        }
      },
      onChangeTiendaF(){

      },
      onChangeTienda(){

      },
      getTienda(tiendaId){
        if(this.tiendas.length >0){
          let itemEnc = this.tiendas.find(m => m.id === tiendaId);
          if(tiendaId>=0){
            return itemEnc.nombre;
          }else{
            return "---";
          }
        }
      },
      getSelectTienda(){
        this.tiendas.forEach(element => {
          if(element.id>0){
            let data = {value:element.id, text:element.nombre};
            this.selectTienda.push(data);
          }
        });
      },
      setFilters(){
        let parsed = JSON.stringify(this.filtro);
        localStorage.setItem('filter', parsed);
        //console.log()
      },
      getFilters(){
        return JSON.parse(localStorage.getItem('filter'));
      },
      loadCajas(){
        //this.filtro.fecha = this.getDate();
        let datafilter = this.getFilters();
        this.filtro.fecha = datafilter!==null?datafilter.fecha:this.getDate();
        axios.get(this.$gate.getApiUrl()+"Tienda").
                  then(({ data }) => {
                    this.tiendas = data; this.getSelectTienda();
                  }).catch( e => {
                    /* si el token es invalido o esta vencido */
                    if (e.response.status == 401) {
                      this.$gate.removeLogin();
                      this.$router.push("/Login");
                    }
                  });
        this.getResults();
      },
    },
    computed: {
      totalGeneralBs: function(){

        let total = [];

        Object.entries(this.detalleDeFactura.detalleFactura).forEach(([key, val]) => {
            total.push(parseFloat(val.total)) // the value of the current key.
        });

        return total.reduce(function(total, num){ return total + num }, 0);

      },
      totalGeneralDolar: function(){

        let total = [];

        Object.entries(this.detalleDeFactura.detalleFactura).forEach(([key, val]) => {
            total.push(parseFloat(val.total)/parseInt(val.tasa)) // the value of the current key.
        });

        return total.reduce(function(total, num){ return total + num }, 0);

      },
      totalBs: function(){
        let total = [];

        Object.entries(this.detalleCajaArqueo).forEach(([key, val]) => {
            total.push(val.totalfacturadobs) // the value of the current key.
        });

        return total.reduce(function(total, num){ return total + num }, 0);

      },
      totalDolar: function(){
        let total = [];

        Object.entries(this.detalleCajaArqueo).forEach(([key, val]) => {
            total.push(val.totalfacturadodolar) // the value of the current key.
        });

        return total.reduce(function(total, num){ return total + num }, 0);

      }
    },
    mounted(){
      this.loadCajas();
    },
    created(){
      //this.loadCajas();
    }
  };
</script>
<style>
.scrollDiv{
  	overflow-y: scroll;
    	height: 300px;
}
.resaltar{
  font-weight: bold;
  background: #ffcdd2;
}
.micursor {cursor: pointer; cursor: hand;}
 .bckgdevolucion{
   background: #f3bdbb;
   font-weight: bold;
 }

 .detallefactura {
    font-size: 0.8125rem;
    white-space: nowrap;
 }
 .bckgmontobs{
   background: #e2e6e7;
   font-weight: bold;
 }
</style>
